import { SortDescendingOutlined, SortAscendingOutlined, } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { Pagination, Input } from 'antd';
import { useDashboardAttendenceList } from 'hooks/reports/reports';
import { useLocation, useNavigate } from 'react-router-dom';
import Image from 'helpers/Image';
import moment from "moment";
import "../style.css";
import TableStateRow from "components/tableState";
import { DASHBOARD_PREVIEW_PAGE_SIZE } from "helpers/commonFunctions";

const AttendanceTableListing = (props) => {

    let navigate = useNavigate();
    const search = useLocation().search;
    const returncall = new URLSearchParams(search).get('returncall');

    const title = props.title;
    const type = props.type;
    const [pageNumber, setPageNumber] = useState(0);
    // A dashboard preview rather than a full listing, so it keeps a short fixed
    // page. The listing screens use DEFAULT_PAGE_SIZE; 25 rows here would make
    // the dashboard scroll past the cards above it.
    const [page] = useState(DASHBOARD_PREVIEW_PAGE_SIZE);
    const [searchKey, setSearchKey] = useState("");
    const [attendenceList, setAttendenceList] = useState([]);
    const [attendenceListDataState, setAttendenceListDataState] = useState([]);
    const [hasMounted, setHasMounted] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
    const [initialValue, setInitialValue] = useState({
        date: moment(),
        type: type,
        searchKey: searchKey,
        pageNumber: pageNumber,
        pageSize: page,
    });

    const [sorting, setSorting] = useState({
        "ts.card_id": null,
        "l.location_name": null,
        "s.site_name": null,
        "ecl.read_time": null,
        "e.name": null,
        "efl.first_in": null,
        "efl.last_out": null,
        "fll.location_name": null,
        "lll.location_name": null,
    });

    const { mutate: getEmployee, data: attendenceListData, isLoading: loading, } = useDashboardAttendenceList();

    const onFetchAttendence = (values) => {
        const formData = JSON.stringify(values);
        getEmployee(formData, {
            onSuccess: (data) => {
                setAttendenceList(data?.data?.content);
                setInitialLoaded(true);
            },
            onError: () => {
                setInitialLoaded(true);
            },
        });
    };

    const onSortChange = async (column) => {
        initialValue.pageNumber = 0;
        initialValue.sortField = column;
        initialValue.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPageNumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitialValue(initialValue);
        setSortField(column);
        setSortMethod(newSorting[column]);
        // setListData([]);
    };

    const searchHandler = (e) => {
        initialValue.searchKey = e.target.value;
        let data = { ...initialValue };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initialValue.pageNumber;
        setInitialValue(data);
        setSearchKey(e.target.value);
    };

    const onChange = (page) => {
        initialValue.pageNumber = page - 1;
        setInitialValue(initialValue);
        setPageNumber(page - 1);
    };

    const currentPage = pageNumber + 1;
    const totalEntries = attendenceListData?.data?.totalElements || 0;
    const startIndex = (currentPage - 1) * page + 1; 
    const endIndex = Math.min(startIndex + page - 1, totalEntries);

    useEffect(() => {
        setHasMounted(true)
        if (hasMounted) {
            onFetchAttendence(initialValue);
            setIsloading(false);
            const intervalId = setInterval(() => {
                setIsloading(true);
                onFetchAttendence(initialValue);
            }, 5000);

            return () => clearInterval(intervalId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, searchKey, hasMounted, sortField, sortMethod]);

    useEffect(() => {
        if (returncall === "Refresh") {
            onFetchAttendence(initialValue);
            setTimeout(() => {
                navigate(window.location.pathname)
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [returncall]);

    useEffect(() => {
        if (attendenceListData) {
            setAttendenceListDataState(attendenceListData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attendenceListData]);

    return (
        <div className="dash-card">
            <div className="dash-card-head">
                <h1>
                    {title}
                    <span className="dash-card-note">{totalEntries} employees, refreshed every few seconds</span>
                </h1>
                <div className="dash-card-search">
                    <Input onChange={searchHandler} placeholder="Search" prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
                </div>
            </div>
            <div className="common-table dashboard-table dashboard-abs-table">
                <table>
                    <thead>
                        <tr>
                            <th>Employee Name {sorting["e.name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("e.name")} /> : <SortDescendingOutlined onClick={() => onSortChange("e.name")} />}</th>
                            <th>Site Name {sorting["s.site_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("s.site_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("s.site_name")} />}</th>
                            <th>Card ID {sorting["ts.card_id"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("ts.card_id")} /> : <SortDescendingOutlined onClick={() => onSortChange("ts.card_id")} />}</th>
                            <th>First In Location {sorting["fll.location_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("fll.location_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("fll.location_name")} />}</th>
                            <th className='txt-cente'>First In {sorting["efl.first_in"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("efl.first_in")} /> : <SortDescendingOutlined onClick={() => onSortChange("efl.first_in")} />}</th>
                            <th>Last Out Location {sorting["lll.location_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("lll.location_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("lll.location_name")} />}</th>
                            <th className='txt-cente'>Last Out {sorting["efl.last_out"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("efl.last_out")} /> : <SortDescendingOutlined onClick={() => onSortChange("efl.last_out")} />}</th>
                                <th>Last Known Location {sorting["l.location_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("l.location_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("l.location_name")} />}</th>
                            <th className='txt-cente'>Last Known Time {sorting["ecl.read_time"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("ecl.read_time")} /> : <SortDescendingOutlined onClick={() => onSortChange("ecl.read_time")} />}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!initialLoaded || (!isloading && loading) ? (
                            <TableStateRow colSpan={9} loading />
                        ) : attendenceList === null || attendenceList === undefined || attendenceList?.length === 0 ? (
                            <TableStateRow colSpan={9}>No attendance recorded yet today</TableStateRow>
                        ) : attendenceList?.map((item, a) => (
                            <tr key={a}>
                                <td>{item?.employeeName}</td>
                                <td>{item?.siteName}</td>
                                <td>{item?.employeeCode}</td>
                                <td>{item?.firstInLocation}</td>
                                <td className='txt-cente'><button className='green'>{item?.firstIn ? moment(item.firstIn, "DD-MM-YYYY hh:mm ss").format('HH:mm:ss') : '-'}</button></td>
                                    <td>{item?.lastOutLocation}</td>
                                <td className='txt-cente'><button className='green'>{item?.lastOut ? moment(item.lastOut, "DD-MM-YYYY hh:mm ss").format('HH:mm:ss') : '-'}</button></td>
                                 <td>{item?.location}</td>
                                <td className='txt-cente'><button className='green'>{item?.lastKnownTime ? moment(item.lastKnownTime, "DD-MM-YYYY hh:mm ss").format('HH:mm:ss') : '-'}</button></td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="dashboard-pagination">
                <h5>Showing {startIndex} to {endIndex} of {totalEntries} entries</h5>
                <Pagination pageSize={page} showSizeChanger={false} showLessItems={false} hideOnSinglePage={true} onChange={onChange} current={pageNumber + 1} total={attendenceListDataState?.data?.totalElements} />
            </div>
        </div>
    )
}

export default AttendanceTableListing;